import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { motion } from 'framer-motion';

// Assets
import Image3 from '../assets/home/urban-heights.jpg';
import vajramImg from '../assets/HeroBanners/vajram.webp';
import satyasLayout from "../assets/DetailPage/Common/satyaslayout.webp"
import vajramPdf from '../assets/pdfs/vajram.pdf';

// PDFs
import satyasPdf from '../assets/pdfs/Satyas.pdf';
import subhamPdf from '../assets/pdfs/subham.pdf';

// Images
import subhamImg from '../assets/HeroBanners/subham.webp';
import Image1 from '../assets/HeroBanners/sathyas.webp';
import Image2 from '../assets/HeroBanners/maha.webp';

// amenities
import crdaImg from "../assets/DetailPage/Common/crda.webp"
import bankloanImg from "../assets/DetailPage/Common/bankloan.png"
import security from "../assets/DetailPage/Common/gated-community.jpg"
import childrenplay from '../assets/DetailPage/Common/playarea.webp'
import opengym from '../assets/DetailPage/Common/opengym.png'
import walking from '../assets/DetailPage/Common/walking.png'
import greenwater from "../assets/DetailPage/Common/greenwater.png"
import opencommunity from "../assets/DetailPage/Common/opencommunity.webp"
import seniorcitizen from "../assets/DetailPage/Common/seniorcitizen.webp"
import watertank from "../assets/DetailPage/Common/watertank.png"
import puredrinking from "../assets/DetailPage/Common/puredrinking.webp"
import drainage from "../assets/DetailPage/Common/drainage.webp"
import numberplate from "../assets/DetailPage/Common/plot_number.jpg"
import underwires from "../assets/DetailPage/Common/underwires.jpg"
import streetlights from "../assets/DetailPage/Common/streetlights.jpg"
import irr from "../assets/DetailPage/Common/irr.webp"
import aToa from "../assets/DetailPage/Common/atoa.webp"
import apsec from "../assets/DetailPage/Common/apsec.webp"
import delhipublic from "../assets/DetailPage/Common/delhipublic.webp"
import arc from "../assets/DetailPage/Common/arc.webp"
import vitsrm from "../assets/DetailPage/Common/vitsrm.webp"
import ap from "../assets/DetailPage/Common/ap.jpg"
import tadikonda from "../assets/DetailPage/Common/tadikonda.webp"
import amravati from "../assets/DetailPage/Common/amaravathicity.jpg"

// near by loc satya
import nh65 from "../assets/DetailPage/satyas/NH-65.webp"
import wideroad from "../assets/DetailPage/satyas/wideroad.webp"
import bel from "../assets/DetailPage/satyas/bel.png"
import bandarport from "../assets/DetailPage/satyas/bandarport.png"
import bza from "../assets/DetailPage/satyas/bza.webp"
import beach from "../assets/DetailPage/satyas/beach.webp"
import vijcity from "../assets/DetailPage/satyas/vijcity.avif"
import hills from "../assets/DetailPage/satyas/hills.webp"


// ammenities subham
import grandentrance from "../assets/DetailPage/subham/grandentrance.webp"
import vastu from "../assets/DetailPage/subham/vastu.webp"
import cctv from "../assets/DetailPage/subham/24by7cc.webp"
import wall from "../assets/DetailPage/subham/compoundwall.webp"
import watersupply from "../assets/DetailPage/subham/watersupply.jpg"
import avenueplant from "../assets/DetailPage/subham/avenuplant.webp"
import electricity from "../assets/DetailPage/subham/electricity.webp"
import oldbroad from "../assets/DetailPage/subham/oldbandarroad.webp"
import ntrcircle from "../assets/DetailPage/subham/ntrcircle.webp"
import ushodaya from "../assets/DetailPage/subham/ushodaya.webp"
import busstand from "../assets/DetailPage/subham/busstand.jfif"
import machilipatnam from "../assets/DetailPage/subham/machilipatnam.jpg"

//maha
import nh16 from "../assets/DetailPage/Common/nh16.webp"
import chilaka from "../assets/DetailPage/Common/chilakaluripeta.webp"
import gunbza from "../assets/DetailPage/Common/gun_bza.webp"
import emergecity from "../assets/DetailPage/Common/emergecity.webp"
import Popup from '../components/Popup';


/* -------------------------------------------------------------------------- */
/*  EMPTY IMAGE PLACEHOLDER (Lightweight Neutral SVG Data URI)                 */
/* -------------------------------------------------------------------------- */
const PLACEHOLDER_IMG =
    "data:image/svg+xml;charset=UTF-8,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%22800%22%20height%3D%22600%22%20viewBox%3D%220%200%20800%20600%22%3E%3Crect%20fill%3D%22%231e293b%22%20width%3D%22800%22%20height%3D%22600%22%2F%3E%3Cpath%20d%3D%22M360%20260l-70%2090h320l-90-120-60%2080z%22%20fill%3D%22%23334155%22%2F%3E%3Ccircle%20cx%3D%22360%22%20cy%3D%22220%22%20r%3D%2225%22%20fill%3D%22%23334155%22%2F%3E%3C%2Fsvg%3E";

const U = (id, w = 800) =>
    `https://images.unsplash.com/photo-${id}?auto=format&fit=crop&w=${w}&q=75`;

const GALLERY = [
    { id: '1600585154340-be6161a56a0c', caption: 'Modern villa living', span: 'row-span-2' },
    { id: '1500382017468-9049fed747ef', caption: 'Open green surroundings', span: '' },
    { id: '1560518883-ce09059eeffa', caption: 'Build your dream home', span: '' },
    { id: '1511895426328-dc8714191300', caption: 'Families, parks and play', span: 'row-span-2' },
    { id: '1449824913935-59a10b8d2000', caption: 'Wide, planned roads', span: '' },
    { id: '1486406146926-c627a92ad1ab', caption: 'Growing city corridor', span: '' },
];

const WebImage = ({ id, tag, alt, className = '', eager = false }) => {
    const [stage, setStage] = useState(0);
    const sources = [
        U(id),
        `https://loremflickr.com/800/600/${encodeURIComponent(tag || 'landscape')}`,
    ];
    if (stage >= sources.length) {
        return (
            <div
                className={`${className} bg-gradient-to-br from-emerald-700 via-teal-800 to-slate-900`}
                role="img"
                aria-label={alt}
            />
        );
    }
    return (
        <img
            src={sources[stage]}
            alt={alt}
            loading={eager ? 'eager' : 'lazy'}
            onError={() => setStage((s) => s + 1)}
            className={className}
        />
    );
};

/* -------------------------------------------------------------------------- */
/*  DATA                                                                      */
/* -------------------------------------------------------------------------- */

export const PROJECTS_DATA = {
    // 1. VAJRAM
    vajram: {
        id: "vajram",
        title: "Vajram",
        tagline: "రాజధానిలో మీ చిరునామా .... Be a Part of Most Happening Project in Amaravathi",
        location: "Tadikonda, Amaravathi",
        developer: "Siddhi Ganapathi Developers Private Limited",
        lpNumber: "LP No. 84/2024 (APCRDA Approved)",
        heroImage: vajramImg,
        pdf: vajramPdf,
        stats: [
            { label: "Total Acres", value: "15 Acres" },
            { label: "Total Plots", value: "140 Open Plots" },
            { label: "Plot Sizes", value: "185 – 751 Sq. Yds" },
            { label: "Approval", value: "APCRDA Approved" },
        ],
        overview:
            "This venture is perfectly situated in a prime location, offering 140 open plots ranging from 185 sq. yds to 751 sq. yds, beautifully spread across 15 acres. Nestled close to the Inner Ring Road and just 1 km from the National Highway, near the fast-developing capital city Amaravathi.",
        locationHighlights: [
            { text: "3 min Drive to Amaravathi IRR (1.5 km)", badge: "1.5 KM", image: irr },
            { text: "500 Meters from Ananthapur-Amaravathi Express Highway", badge: "Expressway", image: aToa },
            { text: "6 km to AP Secretariat Amaravathi", badge: "6 KM", image: apsec },
            { text: "2 km to Delhi Public School", badge: "2 KM", image: delhipublic },
            { text: "5 km to Agriculture Research Center", badge: "5 KM", image: arc },
            { text: "10 min Drive to VIT University & SRM University", badge: "10 Mins", image: vitsrm },
            { text: "10 min Drive to AP High Court", badge: "10 Mins", image: ap },
            { text: "0.5 km to Tadikonda Village", badge: "0.5 KM", image: tadikonda },
            { text: "Proximity to upcoming Cyber City, Iconic Bridge & Sports City", badge: "Future Hub", image: amravati }
        ],
        amenities: [
            { name: "APCRDA Approved Layout", desc: "Clear Title & Immediate Registration", image: crdaImg },
            { name: "40 Feet CC Roads", desc: "Wide and well-engineered concrete roads", image: wideroad },
            { name: "Underground Drainage System", desc: "Fully planned modern sewage network", image: drainage },
            { name: "Underground Electricity", desc: "Safe, wire-free and uninterrupted power lines", image: underwires },
            { name: "Water Tank & Drinking Water", desc: "Dedicated overhead reservoir and water supply", image: puredrinking },
            { name: "100% Vastu Compliance", desc: "Traditional architectural harmony", image: vastu },
            { name: "Compound Wall & Security Arch", desc: "Secured periphery with grand entry gate", image: wall },
            { name: "Children's Play Area & Park", desc: "Dedicated recreation and kids activity zone", image: childrenplay },
            { name: "Avenue Plantation & Track", desc: "Tree-lined boulevard with walking track", image: avenueplant },
            { name: "Designed LED Street Lights", desc: "Bright and energy-efficient lighting setup", image: streetlights },
        ]
    },

    // 2. SATYA'S ELITE
    "satyas-elite": {
        id: "satyas-elite",
        title: "Satya's Elite",
        tagline: "Beyond Luxury, Beyond Ordinary – A Premium Gated Community",
        location: "Kurumaddali, Pamarru",
        developer: "Siddhi Ganapathi Developers Private Limited",
        lpNumber: "APCRDA Approved",
        heroImage: Image1,
        pdf: satyasPdf,
        stats: [
            { label: "Location", value: "Kurumaddali Phase-1" },
            { label: "Layout Facing", value: "National Highway Facing" },
            { label: "Approval", value: "APCRDA Approved" },
        ],
        overview:
            "A premium gated community where prosperity meets lifestyle. Located with direct National Highway facing access, Satya's Elite offers meticulously planned ventures equipped with world-class infrastructure and lifestyle amenities, securing your family's future and long-term investment value.",
        locationHighlights: [
            { text: "National Highway Facing (Direct access to NH-65)", badge: "NH-65", image: nh65 },
            { text: "Existing B.T Road & Wide Road connectivity", badge: "Wide BT", image: wideroad },
            { text: "Just 15 Minutes from BEL Company", badge: "15 Mins", image: bel },
            { text: "Just 30 Minutes from Bandar Port", badge: "30 Mins", image: bandarport },
            { text: "Just 30 Minutes from Vijayawada Airport", badge: "30 Mins", image: bza },
            { text: "Just 35 Minutes from Machilipatnam Beach", badge: "35 Mins", image: beach },
            { text: "Just 35 Minutes from Vijayawada City", badge: "35 Mins", image: vijcity },
            { text: "Surrounded by peaceful green environments and emerging development hubs", badge: "Prime", image: hills }
        ],
        amenities: [
            { name: "APCRDA Approved", desc: "100% legal clearance with bank loan facility", image: crdaImg },
            // { name: "Bank Loan Available", desc: "Supported by national & private banks", image: bankloanImg },
            { name: "Secure Gated Community", desc: "Round-the-clock gated security", image: security },
            { name: "Children's Play Area", desc: "Safe recreational setup for children", image: childrenplay },
            { name: "Jogging & Walking Track", desc: "Dedicated paths for morning & evening runs", image: walking },
            { name: "Open Gym & Meditation Zone", desc: "Dedicated health & wellness space", image: opengym },
            { name: "Landscaped Gardens & Water Features", desc: "Aesthetic green elements across the venture", image: greenwater },
            { name: "Open Community Hall", desc: "Spacious area for gatherings and celebrations", image: opencommunity },
            { name: "Senior Citizen Plaza", desc: "Relaxed shaded seating pavilions", image: seniorcitizen },
            { name: "Overhead Tank & Avenue Plantation", desc: "Consistent water and curated flora", image: watertank },
        ]
    },

    // 3. SUBHAM AVENUES
    "subham-avenues": {
        id: "subham-avenues",
        title: "Subham Avenues",
        tagline: "Luxurious Modern Living – Live Close to the City Surrounded by Nature",
        location: "Pamarru City",
        developer: "Siddhi Ganapathi Developers Private Limited",
        lpNumber: "T.LP.NO: 1168/0270/LP/PMRU/2025 (APCRDA)",
        heroImage: subhamImg,
        pdf: subhamPdf,
        stats: [
            { label: "Total Plots", value: "93 Open Plots" },
            { label: "Plot Extent", value: "136 – 356 Sq. Yds" },
            { label: "Approvals", value: "APCRDA" },
            // { label: "Bank Loan", value: "Available" },
        ],
        overview:
            "Subham Homes / Subham Avenues is a mega gated community housing project designed to bring modern lifestyle and secure living into the heart of Pamarru. Surrounded by nature with superb connectivity to Vijayawada and Machilipatnam, offering high appreciation and immediate growth potential.",
        locationHighlights: [
            { text: "150 Meters from Old Machilipatnam Road (Old Bandar Road)", badge: "150 M", image: oldbroad },
            { text: "500 Meters from N.T.R Circle", badge: "500 M", image: ntrcircle },
            { text: "Backside of Ushodaya Super Market", badge: "Retail", image: ushodaya },
            { text: "5 Mins Drive to Pamarru RTC Bus Stand", badge: "5 Mins", image: busstand },
            { text: "5 Mins Drive to Machilipatnam Highway", badge: "5 Mins", image: machilipatnam },
            { text: "10 Mins Drive to BHEL Company", badge: "10 Mins", image: bel },
            { text: "45 Mins Drive to Machilipatnam Port", badge: "45 Mins", image: bandarport },
            { text: "45 Mins Drive to Vijayawada", badge: "45 Mins", image: vijcity }
        ],
        amenities: [
            { name: "APCRDA Approved Layout", desc: "Clear Title & Immediate Registration", image: crdaImg },
            { name: "Grand Entrance Arch", desc: "Impressive entrance with architectural facade", image: grandentrance },
            { name: "100% Clear Title & Vasthu", desc: "Hassle-free title documentation", image: vastu },
            { name: "40 & 30 Feet Cement Roads", desc: "Durable high-grade concrete circulation roads", image: wideroad },
            { name: "24/7 Security with CCTV", desc: "Comprehensive surveillance for total peace of mind", image: cctv },
            { name: "Designed Compound Wall", desc: "Solid perimeter wall surrounding the layout", image: wall },
            { name: "Water Pipeline to Each Plot", desc: "Individual pressurized tap lines to all boundary plots", image: watersupply },
            { name: "Overhead Tank & Drainage", desc: "Clean water reserve & robust underground drainage", image: watertank },
            { name: "Children's Park & Landscapes", desc: "Lush botanical gardens and green spaces", image: childrenplay },
            { name: "Avenue Plantation & Track", desc: "Shaded green walking pathway", image: avenueplant },
            { name: "Electricity Network", desc: "Safe overhead electrical lines with transformers", image: electricity },
        ]
    },

    // 4. Mahalakshmi's GOLDEN CITY
    "mahalakshmi-golden-city": {
        id: "mahalakshmi-golden-city",
        title: "Mahalakshmi's Golden City",
        tagline: "Own Your Plot • Build Your Future – A Premium Residential Venture",
        location: "Tatapudi, Chilakaluripeta",
        developer: "KVR Developers & Siddhi Ganapathi Developers Pvt. Ltd.",
        lpNumber: "Approved Gated Layout",
        heroImage: Image2,
        pdf: null,
        stats: [
            { label: "Layout Extent", value: "14 Acres" },
            { label: "Location", value: "Beside NH-16" },
            { label: "Community", value: "Gated Layout" },
            // { label: "Bank Loan", value: "Facility Available" },
        ],
        overview:
            "Mahalakshmi's Golden City is a premium 14-acre gated layout venture located beside NH-16, close to the rapidly expanding hub of Chilakaluripeta. Jointly presented by KVR Developers and Siddhi Ganapathi Developers Pvt. Ltd., this development delivers modern residential infrastructure, lush landscapes, and complete lifestyle security.",
        locationHighlights: [
            { text: "Prime layout situated right beside National Highway 16 (NH-16)", badge: "NH-16 Facing", image: nh16 },
            { text: "Close to rapidly growing Chilakaluripeta commercial & residential center", badge: "Strategic Hub", image: chilaka },
            { text: "Direct arterial highway connectivity to Guntur and Vijayawada corridors", badge: "Expressway", image: gunbza },
            { text: "Surrounded by emerging educational, medical, and regional infrastructure", badge: "High Growth", image: emergecity }
        ],
        amenities: [
            { name: "APCRDA Approved Layout", desc: "Clear Title & Immediate Registration", image: crdaImg },
            { name: "Grand Entrance Arch", desc: "Majestic designer gated entry portal", image: grandentrance },
            { name: "Wide BT Roads", desc: "High-standard, long-lasting blacktop roads", image: wideroad },
            { name: "Underground Drainage", desc: "Concealed sanitary and drainage network", image: drainage },
            { name: "Electricity Facility", desc: "Reliable power lines with street illumination", image: electricity },
            { name: "Pure Drinking Water", desc: "Dedicated drinking water supply infrastructure", image: puredrinking },
            { name: "Modern Park & Children's Play Area", desc: "Recreational greens with dedicated play zone", image: childrenplay },
            { name: "Walking Track & Street Lights", desc: "Illuminated pedestrian walking track", image: walking },
            { name: "Lush Green Plantation", desc: "Avenue trees and landscaped botanical borders", image: avenueplant },
            { name: "Nameplate Provision", desc: "Standardized numbering and signage per plot", image: numberplate },
            // { name: "Bank Loan Facility", desc: "Hassle-free loan approvals from leading banks", image: bankloanImg },
        ]
    }
};

/* -------------------------------------------------------------------------- */
/*  SMALL PIECES                                                              */
/* -------------------------------------------------------------------------- */

const SectionHead = ({ title, sub, light = false, right }) => (
    <div className="flex flex-col md:flex-row md:items-end justify-between gap-5 mb-12">
        <div className="max-w-2xl">
            <h2 className={`text-3xl sm:text-4xl lg:text-5xl font-black tracking-tight ${light ? 'text-white' : 'text-slate-900'}`}>
                {title}
            </h2>
            <p className={`mt-3 text-base lg:text-lg ${light ? 'text-slate-300' : 'text-slate-600'}`}>{sub}</p>
        </div>
        {right}
    </div>
);

const PAD = 'w-full px-6 sm:px-10 lg:px-16 xl:px-24';

/* -------------------------------------------------------------------------- */
/*  PAGE                                                                      */
/* -------------------------------------------------------------------------- */

/* -------------------------------------------------------------------------- */
/*  PAGE  (replace ONLY the existing `const ProjectDetails = ...` component)  */
/*  Imports, PROJECTS_DATA, WebImage, SectionHead and PAD stay unchanged.     */
/* -------------------------------------------------------------------------- */

/* -------------------------------------------------------------------------- */
/*  PAGE  (replace ONLY the existing `const ProjectDetails = ...` component)  */
/*  Imports, PROJECTS_DATA, WebImage, SectionHead and PAD stay unchanged.     */
/* -------------------------------------------------------------------------- */

const ProjectDetails = () => {
    const { id } = useParams();
    const [isopenPopUp, setIsOpenPopUp] = useState(false)
    const projectKey = (id && PROJECTS_DATA[id.toLowerCase()]) ? id.toLowerCase() : 'vajram';
    const project = PROJECTS_DATA[projectKey];
    const otherProjects = Object.values(PROJECTS_DATA).filter((p) => p.id !== project.id);

    // Scroll to top immediately when route/project changes
    useEffect(() => {
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: 'instant'
        });
    }, [projectKey]);

    return (
        <div className="w-full bg-white text-slate-800 antialiased selection:bg-emerald-500 selection:text-white">

            {/* 1. HERO (gradient background: title, buttons, details below, banner image beside) */}
            <section className="relative w-full overflow-hidden text-white bg-gradient-to-br from-slate-950 via-emerald-950 to-teal-900">
                <div className="absolute -top-32 -right-32 w-[28rem] h-[28rem] rounded-full bg-emerald-500/20 blur-3xl pointer-events-none" />
                <div className="absolute -bottom-40 -left-32 w-[26rem] h-[26rem] rounded-full bg-teal-400/10 blur-3xl pointer-events-none" />
                <div className="absolute inset-0 bg-[radial-gradient(#10b981_1px,transparent_1px)] [background-size:24px_24px] opacity-10 pointer-events-none" />

                <div className={`${PAD} relative z-10 pt-28 sm:pt-32 lg:pt-36 pb-24 lg:pb-28`}>
                    <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-14 items-center">

                        {/* LEFT: title, buttons, then details */}
                        <motion.div
                            initial={{ opacity: 0, y: 25 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.7 }}
                            className="lg:col-span-6 space-y-5"
                        >
                            <div className="inline-flex items-center gap-2 bg-emerald-500/20 text-emerald-300 border border-emerald-400/40 px-4 py-1.5 rounded-full text-xs font-semibold backdrop-blur-md">
                                <span className="w-2 h-2 rounded-full bg-emerald-400 animate-pulse" />
                                {project.lpNumber}
                            </div>

                            <h1 className="text-5xl sm:text-6xl lg:text-6xl xl:text-7xl font-black tracking-tight leading-[0.95]">
                                {project.title}
                            </h1>

                            <p className="text-base sm:text-lg lg:text-xl text-slate-200 leading-relaxed font-light max-w-3xl">
                                {project.tagline}
                            </p>

                            <div className="flex flex-wrap items-center gap-4 pt-3">
                                {project.pdf && (
                                    <a
                                        href={project.pdf}
                                        download={`${project.title}-Brochure.pdf`}
                                        className="bg-emerald-500 hover:bg-emerald-400 text-slate-950 font-bold px-6 py-3.5 rounded-xl shadow-lg shadow-emerald-500/30 transition inline-flex items-center gap-2.5 text-sm"
                                    >
                                        <svg className="w-4 h-4 fill-current" viewBox="0 0 20 20">
                                            <path d="M4 4a2 2 0 012-2h4.586A2 2 0 0112 2.586L15.414 6A2 2 0 0116 7.414V16a2 2 0 01-2 2H6a2 2 0 01-2-2V4z" />
                                        </svg>
                                        Download brochure (PDF)
                                    </a>
                                )}
                                <button
                                    onClick={() => setIsOpenPopUp(true)}
                                    className="bg-white/10 hover:bg-white/20 border border-white/30 backdrop-blur-md text-white font-semibold px-6 py-3.5 rounded-xl text-sm transition"
                                >
                                    Book a site visit
                                </button>
                                <div className="text-sm text-slate-200 flex items-center gap-2 px-4 py-3 bg-black/30 rounded-xl border border-white/10 backdrop-blur-md">
                                    <svg className="w-4 h-4 text-emerald-400" fill="currentColor" viewBox="0 0 20 20">
                                        <path fillRule="evenodd" d="M10 18s6-5.2 6-10a6 6 0 10-12 0c0 4.8 6 10 6 10zm0-7.5a2.5 2.5 0 100-5 2.5 2.5 0 000 5z" clipRule="evenodd" />
                                    </svg>
                                    {project.location}
                                </div>
                            </div>

                            {/* Details (below the brochure buttons) */}
                            <div className="pt-6 mt-2 border-t border-white/10 space-y-5">
                                <h2 className="text-2xl sm:text-3xl lg:text-4xl font-black tracking-tight leading-tight text-white">
                                    A master-planned place to live and grow your wealth
                                </h2>
                                <p className="text-slate-300 leading-relaxed text-sm sm:text-base lg:text-lg">{project.overview}</p>

                                <div className="grid grid-cols-3 gap-3">
                                    {[
                                        { t: 'Clear title', d: 'Approved layout' },

                                        { t: 'High growth', d: 'Prime corridor' },
                                    ].map((b) => (
                                        <div key={b.t} className="rounded-2xl bg-emerald-500/10 border border-emerald-400/20 p-3 sm:p-4">
                                            <div className="font-bold text-emerald-300 text-sm">{b.t}</div>
                                            <div className="text-xs text-emerald-100/70 mt-0.5">{b.d}</div>
                                        </div>
                                    ))}
                                </div>

                                <div className="p-4 sm:p-5 bg-black/20 border-l-4 border-emerald-400 rounded-r-xl text-sm flex flex-col sm:flex-row sm:items-center justify-between gap-3">
                                    <div>
                                        <span className="block text-xs font-semibold text-slate-400">Official promoter</span>
                                        <span className="font-semibold text-white text-base">{project.developer}</span>
                                    </div>
                                    <span className="text-emerald-700 font-bold text-xs bg-white px-3 py-1.5 rounded shadow-sm shrink-0 self-start sm:self-auto">
                                        APCRDA certified
                                    </span>
                                </div>
                            </div>
                        </motion.div>

                        {/* RIGHT: hero banner image */}
                        <motion.div
                            initial={{ opacity: 0, x: 30 }}
                            animate={{ opacity: 1, x: 0 }}
                            transition={{ duration: 0.7, delay: 0.15 }}
                            className="lg:col-span-6 w-full"
                        >
                            <div className="relative rounded-3xl overflow-hidden shadow-2xl group border-4 border-white/90 bg-slate-950">
                                <img
                                    src={project.heroImage}
                                    alt={project.title}
                                    className="block w-full h-auto object-contain group-hover:scale-105 transition-transform duration-700"
                                />
                                <div className="absolute inset-0 bg-gradient-to-t from-slate-950/70 via-transparent to-transparent pointer-events-none flex items-end p-4 sm:p-6">
                                    <div className="text-white">
                                        <p className="text-xs font-semibold text-emerald-300">Prime location</p>
                                        <p className="text-lg sm:text-xl font-bold">{project.location}</p>
                                    </div>
                                </div>
                            </div>
                        </motion.div>
                    </div>
                </div>
            </section>

            {/* 2. STATS */}
            <section className="w-full relative z-20 -mt-10">
                <div className={PAD}>
                    <div className="bg-white rounded-3xl shadow-2xl border border-slate-100 grid grid-cols-2 md:grid-cols-4 divide-x divide-y md:divide-y-0 divide-slate-100 overflow-hidden">
                        {project.stats.map((item, index) => (
                            <motion.div
                                key={index}
                                initial={{ opacity: 0, y: 15 }}
                                animate={{ opacity: 1, y: 0 }}
                                transition={{ delay: 0.3 + index * 0.1, duration: 0.4 }}
                                className="p-6 lg:p-8"
                            >
                                <div className="text-xs font-semibold text-slate-400">{item.label}</div>
                                <div className="text-xl lg:text-3xl font-extrabold text-emerald-700 mt-1 leading-tight">
                                    {item.value}
                                </div>
                            </motion.div>
                        ))}
                    </div>
                </div>
            </section>

            {/* 3. LIFESTYLE GALLERY */}
            <section className="w-full bg-white py-20 lg:py-24 mt-2 lg:mt-6">
                <div className={PAD}>
                    <SectionHead
                        title="Life around the venture"
                        sub="A glimpse of the lifestyle, greenery and growth that surround your future plot."
                    />
                    <div className="grid grid-cols-2 md:grid-cols-4 auto-rows-[180px] sm:auto-rows-[220px] gap-4">
                        {GALLERY.map((g, i) => (
                            <motion.figure
                                key={g.id}
                                initial={{ opacity: 0, scale: 0.96 }}
                                whileInView={{ opacity: 1, scale: 1 }}
                                viewport={{ once: true }}
                                transition={{ duration: 0.45, delay: i * 0.06 }}
                                className={`relative rounded-3xl overflow-hidden group ${g.span} ${i === 0 ? 'md:col-span-2' : ''}`}
                            >
                                <WebImage
                                    id={g.id}
                                    tag="house,garden"
                                    alt={g.caption}
                                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
                                />
                                <div className="absolute inset-0 bg-gradient-to-t from-slate-950/70 via-transparent to-transparent opacity-80 group-hover:opacity-100 transition" />
                                <figcaption className="absolute bottom-4 left-5 right-5 text-white font-semibold text-sm sm:text-base">
                                    {g.caption}
                                </figcaption>
                            </motion.figure>
                        ))}
                    </div>
                </div>
            </section>

            {/* 4. LOCATION HIGHLIGHTS (swapped: now before amenities) */}
            <section className="w-full bg-slate-100/70 py-20 lg:py-28">
                <div className={PAD}>
                    <SectionHead
                        title="Location & connectivity"
                        sub="Travel times to government centres, universities, workplaces and transport hubs."
                        right={
                            <div className="text-xs font-semibold bg-white border border-slate-200 px-4 py-2 rounded-xl shadow-sm text-slate-600">
                                Verified landmark distances
                            </div>
                        }
                    />

                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                        {project.locationHighlights.map((h, index) => (
                            <motion.div
                                key={index}
                                initial={{ opacity: 0, y: 20 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                viewport={{ once: true }}
                                transition={{ duration: 0.35, delay: (index % 3) * 0.07 }}
                                className="relative h-64 rounded-3xl overflow-hidden group shadow-lg"
                            >
                                <img
                                    src={h.image || PLACEHOLDER_IMG}
                                    alt={h.text}
                                    loading="lazy"
                                    className="absolute inset-0 w-full h-full object-cover group-hover:scale-105 transition-transform duration-700  group-hover:opacity-100"
                                />
                                <div className="absolute inset-0 bg-gradient-to-t from-slate-950 via-slate-950/50 to-slate-950/20" />

                                <span className="absolute top-4 left-4 bg-emerald-500 text-slate-950 text-xs font-extrabold px-3 py-1.5 rounded-full shadow-lg">
                                    {h.badge}
                                </span>

                                <p className="absolute bottom-0 left-0 right-0 p-5 text-white font-semibold text-base leading-snug group-hover:text-emerald-300 transition-colors">
                                    {h.text}
                                </p>
                            </motion.div>
                        ))}
                    </div>
                </div>
            </section>

            {/* 5. AMENITIES (swapped: now after location) */}
            <section className="w-full bg-slate-900 text-white py-20 lg:py-28 relative overflow-hidden">
                <div className="absolute inset-0 bg-[radial-gradient(#10b981_1px,transparent_1px)] [background-size:24px_24px] opacity-10 pointer-events-none" />
                <div className={`${PAD} relative z-10`}>
                    <SectionHead
                        light
                        title="Layout amenities"
                        sub="Carefully engineered specifications for longevity, comfort and a high standard of living."
                        right={
                            <div className="text-slate-300 text-sm hidden md:block text-right">
                                <span className="text-4xl font-black text-emerald-400 block">{project.amenities.length}+</span>
                                curated features
                            </div>
                        }
                    />

                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
                        {project.amenities.map((amenity, idx) => (
                            <motion.div
                                key={idx}
                                initial={{ opacity: 0, y: 25 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                viewport={{ once: true }}
                                transition={{ duration: 0.4, delay: (idx % 4) * 0.06 }}
                                className="group bg-slate-800 rounded-3xl overflow-hidden border border-slate-700/60 hover:border-emerald-400/70 shadow-xl transition-all duration-300 flex flex-col"
                            >
                                <div className="relative h-48 w-full overflow-hidden bg-slate-950">
                                    <img
                                        src={amenity.image || PLACEHOLDER_IMG}
                                        alt={amenity.name}
                                        loading="lazy"
                                        className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700 opacity-90 group-hover:opacity-100"
                                    />
                                    <div className="absolute inset-0 bg-gradient-to-t from-slate-800 via-transparent to-transparent" />
                                </div>

                                <div className="p-5 flex-1 flex flex-col justify-between">
                                    <div>
                                        <h3 className="text-lg font-bold text-white group-hover:text-emerald-400 transition-colors leading-snug">
                                            {amenity.name}
                                        </h3>
                                        <p className="text-sm text-slate-400 mt-2 leading-relaxed">{amenity.desc}</p>
                                    </div>
                                </div>
                            </motion.div>
                        ))}
                    </div>
                </div>
            </section>

            {/* 6. EXPLORE OTHER PROJECTS */}
            <section className={`${PAD} py-20 lg:py-24`}>
                <SectionHead
                    title="Explore our other ventures"
                    sub="More approved layouts from the Siddhi Ganapathi family of projects."
                />
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
                    {otherProjects.map((p) => (
                        <Link
                            key={p.id}
                            to={`/project/${p.id}`}
                            className="group relative h-72 rounded-3xl overflow-hidden shadow-lg block"
                        >
                            <img
                                src={p.heroImage}
                                alt={p.title}
                                className="absolute inset-0 w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
                            />
                            <div className="absolute inset-0 bg-gradient-to-t from-slate-950 via-slate-950/40 to-transparent" />
                            <div className="absolute bottom-0 p-6 text-white">
                                <p className="text-xs text-emerald-300 font-semibold">{p.location}</p>
                                <h3 className="text-2xl font-black mt-1">{p.title}</h3>
                                <p className="text-sm text-slate-300 mt-1 line-clamp-1">{p.tagline}</p>
                            </div>
                        </Link>
                    ))}
                </div>
            </section>

            {/* 7. CTA */}
            <section id="contact" className="relative w-full overflow-hidden py-20 px-6 sm:px-10 lg:px-16 xl:px-24 text-white">
                <WebImage
                    id="1600585154340-be6161a56a0c"
                    tag="villa,home"
                    alt="Dream home"
                    className="absolute inset-0 w-full h-full object-cover"
                />
                <div className="absolute inset-0 bg-emerald-900/85" />
                <div className="relative z-10 flex flex-col lg:flex-row items-center justify-between gap-8">
                    <div className="space-y-3 text-center lg:text-left">
                        <h2 className="text-3xl lg:text-5xl font-black">Interested in {project.title}?</h2>
                        <p className="text-emerald-100 text-base lg:text-lg max-w-xl">
                            Talk to our advisory team to check plot availability, book a site visit, or get transparent pricing.
                        </p>
                    </div>
                    <div className="flex flex-wrap items-center justify-center gap-4">
                        <button
                            onClick={() => setIsOpenPopUp(true)}
                            className="bg-slate-950 hover:bg-slate-900 text-white font-bold px-8 py-4 rounded-xl shadow-lg transition"
                        >
                            Enquire now
                        </button>
                        {project.pdf && (
                            <a
                                href={project.pdf}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="bg-white text-emerald-800 hover:bg-emerald-50 font-bold px-8 py-4 rounded-xl shadow-lg transition"
                            >
                                View full brochure
                            </a>
                        )}
                    </div>
                </div>
            </section>
            {isopenPopUp && <Popup onClose={() => setIsOpenPopUp(false)} />}
        </div>
    );
};

export default ProjectDetails;
